import { render, staticRenderFns } from "./InQuotation.vue?vue&type=template&id=39670235&scoped=true&"
import script from "./InQuotation.vue?vue&type=script&lang=js&"
export * from "./InQuotation.vue?vue&type=script&lang=js&"
import style0 from "./InQuotation.vue?vue&type=style&index=0&id=39670235&prod&lang=scss&scoped=true&"
import style1 from "./InQuotation.vue?vue&type=style&index=1&id=39670235&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39670235",
  null
  
)

export default component.exports